import { type TextInputProps } from '@mantine/core';
import { TextInput } from '../../inputs/TextInput';
import { useEditorContext } from '../EditorContext';
import { ModalEditorItemBase } from './ModalEditorItemBase';

export interface ModalTextItemProps<TFormType> extends TextInputProps {
    label?: string;
    labelWidth?: number;
    fieldKey: keyof TFormType;
    required?: boolean;
}

export const ModalTextItem = <TFormType,>({
    label,
    labelWidth,
    fieldKey,
    required,
    bg,
    ...textInputProps
}: ModalTextItemProps<TFormType>) => {
    const { form, loading, onSave } = useEditorContext<TFormType>();

    const fieldKeyString = fieldKey as string;
    const error = form.errors[fieldKeyString];

    return (
        <ModalEditorItemBase
            label={label}
            labelWidth={labelWidth}
            error={error}
            required={required}
            submitChanges={onSave}
        >
            <TextInput
                key={form.key(fieldKeyString)}
                {...form.getInputProps(fieldKeyString)}
                readOnly={loading}
                required={required}
                error={false}
                {...textInputProps}
            />
        </ModalEditorItemBase>
    );
};
